module.exports = __webpack_public_path__ + "img/guge.46a8c831.png";